import { Box, Dialog, DialogContent, DialogTitle } from "@mui/material";
import Grid from "@mui/material/Grid2";
import {
  addCompetitorToMaster,
  competitorToMasterState,
  competitorToMasterStateMange,
} from "./data";
import { useEffect, useReducer, useState } from "react";
import MaterialInput from "../../../../components/MaterialInput";
import MaterialTypography from "../../../../components/MaterialTypography";
import MaterialBox from "../../../../components/MaterialBox";
import MaterialButton from "../../../../components/MaterialButton";
import BASEURL from "../../../../pages/Utils/Baseurl";
import { getCompetitorProductById } from "../data";
import request from "graphql-request";
import URL from "../../../../pages/Utils/url";
import { useLoading } from "../../../../context/LodingContext";
import Swal from "sweetalert2";
import { useAuthData } from "../../../context/loginContext/LoginContextProvider";
import { allBrands } from "../../brand/brandData";
import MaterialSelect from "../../../../components/MasterSelect";

const styles = {
  table: {
    width: "100%",
    borderCollapse: "collapse",
    borderSpacing: "0 10px",
    fontFamily: "Arial, sans-serif",
    fontSize: "small",
    backgroundColor: "#f8f8f8", // Light background for the table
    color: "#333", // Darker text for readability
  },
  tableHeaderRow: {
    backgroundColor: "#e0e0e0",
    fontSize: "12px",
  },
  tableCell: {
    padding: "8px",
    border: "1px solid #ddd",
    fontSize: "12px",
  },
  tableEvenRow: {
    backgroundColor: "#f2f2f2",
  },
  productImage: {
    width: "50px",
    height: "50px",
    display: "block",
    margin: "auto",
  },
  dialogTitle: {
    backgroundColor: "white",
    color: "Black",
    fontWeight: "bold",
    borderTopLeftRadius: 8,
    borderTopRightRadius: 8,
  },
  dialogContent: {
    backgroundColor: "white",
    padding: "20px",
    borderBottomLeftRadius: 8,
    borderBottomRightRadius: 8,
    overflow: "hidden",
  },
  requiredAsterisk: {
    color: "red",
  },
  numberInputSpinButton: {
    "& input::-webkit-inner-spin-button, & input::-webkit-outer-spin-button": {
      WebkitAppearance: "none",
      margin: 0,
    },
    "& input": {
      MozAppearance: "textfield",
    },
  },
};

const CompetitorToMaster = ({
  open = false,
  setOpen,
  productID,
  setProductID,
  filterCompetitorAnalysisData,
}) => {
  const [CompetitorToMaster, dispatch] = useReducer(
    competitorToMasterStateMange,
    competitorToMasterState
  );
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [brandCodeOption, setBrandCodeOption] = useState([]);
  const [brandLoading, setBrandLoading] = useState(false);

  const { setCirleLoading } = useLoading();
  const { userId } = useAuthData();

  useEffect(() => {
    if (productID) {
      fetchAllData();
    }
  }, [productID]);

  const handleClose = () => {
    setOpen(false);
    setProductID(null);
    setData(null);
    dispatch({
      value: "",
      name: "Uom",
    });
    dispatch({
      value: "",
      name: "leastUom",
    });
    dispatch({
      value: "",
      name: "conversion",
    });
    dispatch({
      value: "",
      name: "bas",
    });
    dispatch({
      value: "",
      name: "vat",
    });
    dispatch({
      value: "",
      name: "cod",
    });
    dispatch({
      value: "",
      name: "csh",
    });
    dispatch({
      value: "",
      name: "smt",
    });
    dispatch({
      value: "",
      name: "vansl",
    });
  };
  const fetchAllData = async () => {
    setIsLoading(true);
    setBrandLoading(true);

    try {
      const [brandRes, competitorRes] = await Promise.all([
        request(BASEURL, allBrands),
        request(BASEURL, getCompetitorProductById, {
          id: productID,
        }),
      ]);

      // Handle allBrands response
      const brandSuccess = brandRes?.allBrands?.success;
      const brandMessage = brandRes?.allBrands?.message;
      if (brandSuccess) {
        // setProductBrandOption(brandRes?.allBrands?.data);
        setBrandCodeOption(brandRes?.allBrands?.data);
      } else {
        Swal.fire({
          position: "top",
          icon: "error",
          title: brandMessage,
          showConfirmButton: true,
        });
        // setProductBrandOption([]);
      }

      // Handle getCompetitorProductById response
      const competitorData = competitorRes?.getCompetitorProductById?.data?.[0];
      setData(competitorData);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setIsLoading(false);
      setBrandLoading(false);
    }
  };

  const checkAllFields = () => {
    let allowSubmit = false;
    if (
      CompetitorToMaster.leastUomStatus === "success" &&
      CompetitorToMaster.brandCodeStatus === "success" &&
      CompetitorToMaster.UomStatus === "success" &&
      CompetitorToMaster.conversionStatus === "success" &&
      CompetitorToMaster.basStatus === "success" &&
      CompetitorToMaster.codStatus === "success" &&
      CompetitorToMaster.cshStatus === "success" &&
      CompetitorToMaster.smtStatus === "success" &&
      CompetitorToMaster.vanslStatus === "success"
    ) {
      allowSubmit = true;
    } else {
      allowSubmit = false;
    }
    return allowSubmit;
  };

  const handleSubmit = async () => {
    setCirleLoading(true);
    try {
      const res = await request(
        BASEURL,
        addCompetitorToMaster,

        {
          input: {
            competitorId: productID,
            productBrandCode: CompetitorToMaster?.brandCode?.label,
            productUom: CompetitorToMaster?.leastUom,
            baseUom: CompetitorToMaster?.Uom,
            conversion: CompetitorToMaster?.conversion,
            vat: CompetitorToMaster?.vat,
            bas: CompetitorToMaster?.bas,
            cod: CompetitorToMaster?.cod,
            csh: CompetitorToMaster?.csh,
            smt: CompetitorToMaster?.smt,
            vansl: CompetitorToMaster?.vansl,
          },
        }
      );

      const response = res?.addCompetitorToMasterProduct.success;
      const message = res?.addCompetitorToMasterProduct.message;

      if (response) {
        Swal.fire({
          position: "top",
          icon: "success",
          title: message,
          showConfirmButton: true,
        }).then(() => {
          handleClose();
        });
      } else {
        Swal.fire({
          position: "top",
          icon: "error",
          title: message,
          showConfirmButton: true,
        });
      }
    } catch (error) {
    } finally {
      setCirleLoading(false);
      filterCompetitorAnalysisData();
    }
  };
  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle sx={styles.dialogTitle}>
        Competitor To Product Master
      </DialogTitle>

      <DialogContent sx={styles.dialogContent}>
        <Box>
          {isLoading && <Box>Loading...</Box>}
          {!isLoading && (
            <Box>
              <table style={styles.table}>
                <thead>
                  <tr style={styles.tableHeaderRow}>
                    <th style={styles.tableCell}>Product Code</th>
                    <th style={styles.tableCell}>Product Category</th>
                    <th style={styles.tableCell}>Product Name</th>
                    <th style={styles.tableCell}>Competitor Price</th>
                    <th style={styles.tableCell}>Product Image</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td style={styles.tableCell}>
                      {data?.productCode || "N/A"}
                    </td>
                    <td style={styles.tableCell}>
                      {data?.productCategory || "N/A"}
                    </td>
                    <td style={styles.tableCell}>
                      {data?.productName || "N/A"}
                    </td>
                    <td style={styles.tableCell}>{data?.competitorPrice}</td>
                    <td style={styles.tableCell}>
                      {data?.productImage ? (
                        <img
                          src={`${URL}media/${data.productImage}`}
                          alt={data.productName}
                          style={styles.productImage}
                        />
                      ) : (
                        "No Image"
                      )}
                    </td>
                  </tr>
                </tbody>
              </table>
            </Box>
          )}
        </Box>
        <Box sx={{ padding: "2px 0px" }}>
          <Grid container spacing={2}>
            <Grid size={{ lg: 4, xs: 5, sm: 3 }}>
              <MaterialBox lineHeight={0} display="inline-block">
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  Brand Code <span style={{ color: "red" }}>*</span>
                </MaterialTypography>
              </MaterialBox>
              <MaterialSelect
                name="brandCode"
                value={CompetitorToMaster?.brandCode}
                customStyles={{ optionPadding: 20 }}
                options={brandCodeOption?.map((item) => {
                  return {
                    value: item?.brandCode,
                    label: item?.brandCode,
                  };
                })}
                onChange={(e, s) => dispatch({ value: e, name: "brandCode" })}
                error={
                  CompetitorToMaster.brandCodeStatus === "error" ? true : false
                }
                success={
                  CompetitorToMaster.brandCodeStatus === "success"
                    ? true
                    : false
                }
                isLoading={brandLoading}
                isClearable
              />
            </Grid>
            <Grid size={{ lg: 4, xs: 5, sm: 3 }}>
              <MaterialBox lineHeight={0} display="inline-block">
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  UOM <span style={styles.requiredAsterisk}>*</span>
                </MaterialTypography>
              </MaterialBox>
              <MaterialInput
                value={CompetitorToMaster?.Uom}
                name="Uom"
                placeholder="Enter UOM"
                onChange={(e) =>
                  dispatch({ value: e?.target?.value, name: "Uom" })
                }
                error={CompetitorToMaster.UomStatus === "error" ? true : false}
                success={
                  CompetitorToMaster.UomStatus === "success" ? true : false
                }
              />
            </Grid>
            <Grid size={{ lg: 4, xs: 5, sm: 3 }}>
              <MaterialBox lineHeight={0} display="inline-block">
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  Least UOM <span style={styles.requiredAsterisk}>*</span>
                </MaterialTypography>
              </MaterialBox>
              <MaterialInput
                value={CompetitorToMaster?.leastUom}
                name="leastUom"
                placeholder="Enter Least UOM"
                onChange={(e) =>
                  dispatch({ value: e?.target?.value, name: "leastUom" })
                }
                error={
                  CompetitorToMaster.leastUomStatus === "error" ? true : false
                }
                success={
                  CompetitorToMaster.leastUomStatus === "success" ? true : false
                }
              />
            </Grid>
            <Grid size={{ lg: 4, xs: 5, sm: 3 }}>
              <MaterialBox lineHeight={0} display="inline-block">
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  Conversion <span style={styles.requiredAsterisk}>*</span>
                </MaterialTypography>
              </MaterialBox>
              <MaterialInput
                value={CompetitorToMaster?.conversion}
                type="number"
                name="conversion"
                placeholder="Enter Conversion"
                onChange={(e) =>
                  dispatch({ value: e?.target?.value, name: "conversion" })
                }
                error={
                  CompetitorToMaster.conversionStatus === "error" ? true : false
                }
                success={
                  CompetitorToMaster.conversionStatus === "success"
                    ? true
                    : false
                }
                onKeyDown={(e) => {
                  if (["e", "E", "+", "-"].includes(e.key)) {
                    e.preventDefault();
                  }
                }}
                sx={styles.numberInputSpinButton}
              />
            </Grid>
            <Grid size={{ lg: 4, xs: 5, sm: 3 }}>
              <MaterialBox lineHeight={0} display="inline-block">
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  VAT <span style={styles.requiredAsterisk}>*</span>
                </MaterialTypography>
              </MaterialBox>
              <MaterialInput
                value={CompetitorToMaster?.vat}
                type="number"
                name="vat"
                placeholder="Enter VAT"
                onChange={(e) =>
                  dispatch({ value: e?.target?.value, name: "vat" })
                }
                error={CompetitorToMaster.vatStatus === "error" ? true : false}
                success={
                  CompetitorToMaster.vatStatus === "success" ? true : false
                }
                onKeyDown={(e) => {
                  if (["e", "E", "+", "-"].includes(e.key)) {
                    e.preventDefault();
                  }
                }}
                sx={styles.numberInputSpinButton}
              />
            </Grid>
            <Grid size={{ lg: 4, xs: 5, sm: 3 }}>
              <MaterialBox lineHeight={0} display="inline-block">
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  BAS <span style={styles.requiredAsterisk}>*</span>
                </MaterialTypography>
              </MaterialBox>
              <MaterialInput
                value={CompetitorToMaster?.bas}
                type="number"
                name="bas"
                placeholder="Enter BAS"
                onChange={(e) => {
                  const value = e.target.value;
                  if (Number(value) >= 0 || value === "") {
                    dispatch({ value: e?.target?.value, name: "bas" });
                  }
                }}
                error={CompetitorToMaster.basStatus === "error" ? true : false}
                success={
                  CompetitorToMaster.basStatus === "success" ? true : false
                }
                onKeyDown={(e) => {
                  if (["e", "E", "+", "-"].includes(e.key)) {
                    e.preventDefault();
                  }
                }}
                sx={styles.numberInputSpinButton}
              />
            </Grid>
            <Grid size={{ lg: 4, xs: 5, sm: 3 }}>
              <MaterialBox lineHeight={0} display="inline-block">
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  COD <span style={styles.requiredAsterisk}>*</span>
                </MaterialTypography>
              </MaterialBox>
              <MaterialInput
                type="number"
                value={CompetitorToMaster?.cod}
                name="cod"
                placeholder="Enter COD"
                onChange={(e) =>
                  dispatch({ value: e?.target?.value, name: "cod" })
                }
                error={CompetitorToMaster.codStatus === "error" ? true : false}
                success={
                  CompetitorToMaster.codStatus === "success" ? true : false
                }
                onKeyDown={(e) => {
                  if (["e", "E", "+", "-"].includes(e.key)) {
                    e.preventDefault();
                  }
                }}
                sx={styles.numberInputSpinButton}
              />
            </Grid>
            <Grid size={{ lg: 4, xs: 5, sm: 3 }}>
              <MaterialBox lineHeight={0} display="inline-block">
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  CSH <span style={styles.requiredAsterisk}>*</span>
                </MaterialTypography>
              </MaterialBox>
              <MaterialInput
                type="number"
                value={CompetitorToMaster?.csh}
                name="csh"
                placeholder="Enter CSH"
                onChange={(e) =>
                  dispatch({ value: e?.target?.value, name: "csh" })
                }
                error={CompetitorToMaster.cshStatus === "error" ? true : false}
                success={
                  CompetitorToMaster.cshStatus === "success" ? true : false
                }
                onKeyDown={(e) => {
                  if (["e", "E", "+", "-"].includes(e.key)) {
                    e.preventDefault();
                  }
                }}
                sx={styles.numberInputSpinButton}
              />
            </Grid>
            <Grid size={{ lg: 4, xs: 5, sm: 3 }}>
              <MaterialBox lineHeight={0} display="inline-block">
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  SMT <span style={styles.requiredAsterisk}>*</span>
                </MaterialTypography>
              </MaterialBox>
              <MaterialInput
                type="number"
                value={CompetitorToMaster?.smt}
                name="smt"
                placeholder="Enter SMT"
                onChange={(e) =>
                  dispatch({ value: e?.target?.value, name: "smt" })
                }
                error={CompetitorToMaster.smtStatus === "error" ? true : false}
                success={
                  CompetitorToMaster.smtStatus === "success" ? true : false
                }
                onKeyDown={(e) => {
                  if (["e", "E", "+", "-"].includes(e.key)) {
                    e.preventDefault();
                  }
                }}
                sx={styles.numberInputSpinButton}
              />
            </Grid>
            <Grid size={{ lg: 4, xs: 5, sm: 3 }}>
              <MaterialBox lineHeight={0} display="inline-block">
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  VANSL <span style={styles.requiredAsterisk}>*</span>
                </MaterialTypography>
              </MaterialBox>
              <MaterialInput
                type="number"
                value={CompetitorToMaster?.vansl}
                name="vansl"
                placeholder="Enter VANSL"
                onChange={(e) =>
                  dispatch({ value: e?.target?.value, name: "vansl" })
                }
                error={
                  CompetitorToMaster.vanslStatus === "error" ? true : false
                }
                success={
                  CompetitorToMaster.vanslStatus === "success" ? true : false
                }
                onKeyDown={(e) => {
                  if (["e", "E", "+", "-"].includes(e.key)) {
                    e.preventDefault();
                  }
                }}
                sx={styles.numberInputSpinButton}
              />
            </Grid>
          </Grid>
        </Box>
        <MaterialBox
          display="flex"
          justifyContent="flex-end"
          alignItems="center"
        >
          <MaterialButton
            sx={{ m: 2 }}
            variant="gradient"
            color="dark"
            onClick={handleClose}
          >
            Cancel
          </MaterialButton>

          <MaterialButton
            sx={{ m: 2 }}
            variant="gradient"
            color="dark"
            onClick={handleSubmit}
            disabled={!checkAllFields()}
          >
            Submit
          </MaterialButton>
        </MaterialBox>
      </DialogContent>
    </Dialog>
  );
};

export default CompetitorToMaster;
